import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { KalenderArbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByArbeitsbereiche/KalenderArbeitsbereich';
import { filterRotationsplaene } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/filterRotationsplaene';
import { filterRotationsplaeneByArbeitsbereiche } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/filterRotationsplaeneByArbeitsbereiche';
import {
  sortRotationsplaene,
  sortRotationsplaeneByArbeitsbereich,
} from '@/domain/mitarbeiter/features/rotationsplan/features/shared/sortRotationsplaene';
import {
  type KalenderFilterOptions,
  RotationsplanFeatureProps,
  type UebersichtFilterOptions,
} from '@/domain/mitarbeiter/features/rotationsplan/features/shared/types';

export function applyDefaultFilterAndSortingForRotationsplaene(
  rotationsplaene: Rotationsplan[],
  type: keyof KalenderFilterOptions | keyof UebersichtFilterOptions,
  filterInput:
    | KalenderFilterOptions[keyof KalenderFilterOptions]
    | UebersichtFilterOptions[keyof UebersichtFilterOptions],
  otherFilters: KalenderFilterOptions | UebersichtFilterOptions,
  istSortierungAufsteigend: boolean,
) {
  const sorted = sortRotationsplaene(rotationsplaene, istSortierungAufsteigend);

  return filterRotationsplaene(type, filterInput, otherFilters, sorted);
}

export function applyDefaultFilterAndSortingForRotationsplaeneByArbeitsbereiche(
  rotationsplaene: KalenderArbeitsbereich[],
  defaultStore: RotationsplanFeatureProps,
) {
  const sorted = sortRotationsplaeneByArbeitsbereich(
    rotationsplaene,
    defaultStore.ui.kalender.istSortierungAufsteigend,
  );

  return filterRotationsplaeneByArbeitsbereiche(
    'standorte',
    defaultStore.ui.kalender.filter.standorte,
    defaultStore.ui.kalender.filter,
    sorted,
  );
}
